<template>
  <section class="bookmarklet-card">
    <div class="bookmarklet-icon" aria-hidden="true">↗</div>
    <div>
      <h2>Ajout express depuis Yahoo Auctions</h2>
      <p>
        Glissez le bouton dans votre barre de favoris. Depuis une annonce,
        cliquez dessus pour l’ajouter sans installer d’extension.
      </p>
    </div>
    <a
      :href="bookmarklet"
      class="bookmarklet-link"
      draggable="true"
      title="Glissez ce bouton dans la barre de favoris"
      @click.prevent
      >＋ Suivre avec Prexens</a
    >
    <button type="button" class="copy-bookmarklet" @click="copyBookmarklet">
      {{ copied ? "Code copié" : "Copier le code" }}
    </button>
  </section>
</template>

<script>
import { computed, ref } from "vue";
export default {
  name: "BookmarkletCard",
  setup() {
    const copied = ref(false);
    const bookmarklet = computed(() => {
      const captureUrl = `${window.location.origin}/capture#url=`;
      return `javascript:(()=>{window.open('${captureUrl}'+encodeURIComponent(location.href),'_blank','noopener,noreferrer')})()`;
    });
    const copyBookmarklet = async () => {
      try {
        await navigator.clipboard.writeText(bookmarklet.value);
        copied.value = true;
        window.setTimeout(() => (copied.value = false), 1800);
      } catch {
        window.prompt(
          "Copiez ce code dans l’adresse d’un favori :",
          bookmarklet.value
        );
      }
    };
    return { bookmarklet, copied, copyBookmarklet };
  },
};
</script>

<style scoped>
.bookmarklet-card {
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 14px;
  margin-top: 16px;
  padding: 18px 20px;
  border: 1px solid #dce4eb;
  border-radius: 12px;
  background: #fff;
}
.bookmarklet-icon {
  display: grid;
  width: 42px;
  height: 42px;
  place-items: center;
  border-radius: 9px;
  background: #e9f7f1;
  color: #168a64;
  font-size: 18px;
  font-weight: 800;
}
.bookmarklet-card h2 {
  margin: 0;
  font-family: "Manrope", "DM Sans", sans-serif;
  font-size: 14px;
}
.bookmarklet-card p {
  margin: 4px 0 0;
  color: #727d8d;
  font-size: 11px;
  line-height: 1.5;
}
.bookmarklet-link,
.copy-bookmarklet {
  display: inline-flex;
  min-height: 36px;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  border: 1px solid #172235;
  border-radius: 8px;
  background: #172235;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
}
.copy-bookmarklet {
  border-color: #cfd6df;
  background: #fff;
  color: #4e596a;
  cursor: pointer;
}
@media (max-width: 640px) {
  .bookmarklet-card {
    grid-template-columns: 42px minmax(0, 1fr);
  }
  .bookmarklet-link {
    grid-column: 1/-1;
    width: 100%;
  }
  .copy-bookmarklet {
    grid-column: 1/-1;
    justify-self: center;
  }
}
</style>
